import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMultiPromptRunnerStatus,
  BackendQueryGetMultiPromptRunnerStatusArgs,
} from 'src/types/backend';

const QUERY = gql`
  query GetMultiPromptRunnerStatus($projectId: ID!, $chainId: ID, $csvChainId: ID) {
    getMultiPromptRunnerStatus(projectId: $projectId, chainId: $chainId, csvChainId: $csvChainId) {
      chainId
      csvChainId
      status
    }
  }
`;

type Variables = BackendQueryGetMultiPromptRunnerStatusArgs;
type Result = BackendMultiPromptRunnerStatus;

export const getMultiPromptRunnerStatus = async (variables: Variables) => {
  const response = await executeGqlQuery({ query: QUERY, variables });
  return getSingleProp<Result>(response.data);
};
